import { ApiProviderProps } from "providers/ApiProvider/types";

export const ApiMiddleware: ApiProviderProps["middleware"] = {
  onModelsUpdate(args, context) {
    return args;
  },
};
